var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.25H17.75V3C17.75 2.59 17.41 2.25 17 2.25C16.59 2.25 16.25 2.59 16.25 3V3.25H12.75V3C12.75 2.59 12.41 2.25 12 2.25C11.59 2.25 11.25 2.59 11.25 3V3.25H7.75V3C7.75 2.59 7.41 2.25 7 2.25C6.59 2.25 6.25 2.59 6.25 3V3.25H5C3.48 3.25 2.25 4.48 2.25 6V18C2.25 19.52 3.48 20.75 5 20.75H19C20.52 20.75 21.75 19.52 21.75 18V6C21.75 4.48 20.52 3.25 19 3.25ZM20.25 18C20.25 18.69 19.69 19.25 19 19.25H5C4.31 19.25 3.75 18.69 3.75 18V6C3.75 5.31 4.31 4.75 5 4.75H6.25V5C6.25 5.41 6.59 5.75 7 5.75C7.41 5.75 7.75 5.41 7.75 5V4.75H11.25V5C11.25 5.41 11.59 5.75 12 5.75C12.41 5.75 12.75 5.41 12.75 5V4.75H16.25V5C16.25 5.41 16.59 5.75 17 5.75C17.41 5.75 17.75 5.41 17.75 5V4.75H19C19.69 4.75 20.25 5.31 20.25 6V18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.7036C6.59 11.7036 6.25 12.0436 6.25 12.4536C6.25 12.8636 6.59 13.2036 7 13.2036C7.41 13.2036 7.75 12.8636 7.75 12.4536C7.75 12.0436 7.42 11.7036 7 11.7036Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.70361C6.59 7.70361 6.25 8.04361 6.25 8.45361C6.25 8.86361 6.59 9.20361 7 9.20361C7.41 9.20361 7.75 8.86361 7.75 8.45361C7.75 8.04361 7.42 7.70361 7 7.70361Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.7036C11.59 11.7036 11.25 12.0436 11.25 12.4536C11.25 12.8636 11.59 13.2036 12 13.2036C12.41 13.2036 12.75 12.8636 12.75 12.4536C12.75 12.0436 12.42 11.7036 12 11.7036Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.70361C11.59 7.70361 11.25 8.04361 11.25 8.45361C11.25 8.86361 11.59 9.20361 12 9.20361C12.41 9.20361 12.75 8.86361 12.75 8.45361C12.75 8.04361 12.42 7.70361 12 7.70361Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.7036C16.59 11.7036 16.25 12.0436 16.25 12.4536C16.25 12.8636 16.59 13.2036 17 13.2036C17.41 13.2036 17.75 12.8636 17.75 12.4536C17.75 12.0436 17.42 11.7036 17 11.7036Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.70361C16.59 7.70361 16.25 8.04361 16.25 8.45361C16.25 8.86361 16.59 9.20361 17 9.20361C17.41 9.20361 17.75 8.86361 17.75 8.45361C17.75 8.04361 17.42 7.70361 17 7.70361Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.7036C6.59 15.7036 6.25 16.0436 6.25 16.4536C6.25 16.8636 6.59 17.2036 7 17.2036C7.41 17.2036 7.75 16.8636 7.75 16.4536C7.75 16.0436 7.42 15.7036 7 15.7036Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.7036C11.59 15.7036 11.25 16.0436 11.25 16.4536C11.25 16.8636 11.59 17.2036 12 17.2036C12.41 17.2036 12.75 16.8636 12.75 16.4536C12.75 16.0436 12.42 15.7036 12 15.7036Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.860b8aef75599ae65e4cfdf4f71a241c.svg";
export { ForwardRef as ReactComponent };